import type { FC } from 'react'
import React from 'react'

import type { LabelProps } from './types'
import type { PrivateThemeUiProps } from '../../../styles-system/create-component'
import { TextPrivate } from '../text/text'

const Label: FC<LabelProps> = React.forwardRef<
  HTMLLabelElement,
  LabelProps & PrivateThemeUiProps & { inline?: boolean }
>(function Label(props, ref) {
  const { variant = 'label', ellipsis = true, __css = {}, ...rest } = props
  return (
    //@ts-ignore
    <TextPrivate
      ref={ref}
      as="label"
      variant={variant}
      ellipsis={ellipsis}
      __themeKey="forms"
      __css={{
        display: 'inline-block',
        ...__css
      }}
      {...rest}
    />
  )
})

export default Label
